<template>
    <button
        v-tippy="t('editorToggleHeader2')"
        :class="[
            buttonState(
                editor.can().toggleHeading({ level: 2 }),
                editor.isActive('heading', { level: 2 }),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleHeading({ level: 2 })"
        @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
    >
        <MdiFormatHeader2 class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatHeader2 from 'materialdesignicons-vue3/icons/MdiFormatHeader2.js';

    defineExpose({
        name: 'FormatHeader2Button',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
